import PropTypes from 'prop-types'
import React from 'react'
import { connect } from 'react-redux'
import { GatewayProvider, GatewayDest } from 'react-gateway'
import SnackbarContainer from 'containers/Snackbar'
import ModalsContainer from 'containers/Modals'

import Header from 'components/Header'
import Footer from 'components/Footer'

import classes from './CoreLayout.scss'
import 'styles/core.scss'

import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider'
import injectTapEventPlugin from 'react-tap-event-plugin'

// Needed for Material-UI and onTouchTap
// http://stackoverflow.com/a/34015469/988941
injectTapEventPlugin()

export const CoreLayout = ({ children, isAdmin, isLoggedIn }) => (
  <MuiThemeProvider>
    <GatewayProvider>
      <div>
        <div className={classes.primary}>
          <Header isAdmin={isAdmin} isLoggedIn={isLoggedIn} />

          <main className={classes.content}>
            {children}
          </main>

          <Footer />

          <GatewayDest name='feedback' className={classes.feedback} />
        </div>

        <div className={classes.bottom}>
          <SnackbarContainer />
          <GatewayDest name='sticky' className={classes['sticky-gateway']} />
        </div>

        {/* blank div so we can add padding for the bottom on mobile */}
        <div />

        <ModalsContainer />
        <GatewayDest name='reports' className={classes['reports-gateway']} />
      </div>
    </GatewayProvider>
  </MuiThemeProvider>
)

CoreLayout.propTypes = {
  children: PropTypes.element.isRequired,
  isLoggedIn: PropTypes.bool,
  isAdmin: PropTypes.bool
}

CoreLayout.defaultProps = {
  isLoggedIn: false,
  isAdmin: false
}

const mapStateToProps = (state, ownProps) => ({
  isAdmin: state.auth && state.auth.isAdmin,
  isLoggedIn: state.auth && state.auth.isLoggedIn
})

export default connect(mapStateToProps)(CoreLayout)



// WEBPACK FOOTER //
// ./src/layouts/CoreLayout/CoreLayout.js